
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Button, CircularProgress, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper
} from "@mui/material";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import baseURL from "../../config";
import Navbar from "../../Navbar/Navbar";

const PendingSignOffList = () => {
  const [pendingData, setPendingData] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

  const fetchPendingSignOns = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseURL}/api/getAllPendingSignOff`);
      setPendingData(res.data.pendingDetails || []);
    //   console.log("res.data.pendingDetails", res.data.pendingDetails)
    } catch (error) {
      console.error("Error fetching pending sign-ons:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingSignOns();
  }, []);

  // Export to Excel
  // Export to Excel
  const handleExportExcel = () => {
    if (!pendingData.length) return;

    const formattedData = pendingData.map((item, index) => ({
      SNo: index + 1,
      VesselOwner: item?.contractId?.vesselOwner?.company_name || "",
      VesselName: item?.contractId?.ShipDetails?.vesselname || "",
      CrewingAgent: item?.contractId?.crewingAgent?.agentName || "",
      CrewIndosNo: item?.crewId?.indosno || "",
      CrewName: item?.crewId?.name || "",
      CrewEmail: item?.crewId?.email || "",
      
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "PendingSignOns");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `PendingSignOns_${Date.now()}.xlsx`);
  };


  if (loading) return <CircularProgress />;

  return (
    <div>
      <Navbar />

      <Button
        variant="contained"
        color="primary"
        onClick={handleExportExcel}
        style={{ margin: "20px 0" }}
      >
        Export SignOff Details
      </Button>

      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ "& .MuiTableCell-root": { fontWeight: "bold" } }}>
            <TableRow>
              <TableCell>S.No</TableCell>
              <TableCell>Vessel Owner</TableCell>
              <TableCell>Vessel</TableCell>
              <TableCell>Crewing Agent</TableCell>
              <TableCell>Indos No</TableCell>
              <TableCell>Crew Name</TableCell>
              <TableCell>Email</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pendingData.map((item, index) => (
              <TableRow key={item._id}>
                {/* {console.log("pendingdata", item)} */}
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item?.contractId?.vesselOwner?.company_name}</TableCell>
                <TableCell>{item?.contractId?.ShipDetails?.vesselname}</TableCell>
                <TableCell>{item?.contractId?.crewingAgent?.agentName}</TableCell>
                <TableCell>{item.crewId?.indosno}</TableCell>
                <TableCell>{item.crewId?.name}</TableCell>
                <TableCell>{item.crewId?.email}</TableCell>
                


              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default PendingSignOffList;
